import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  standalone: false,
})
export class CallbackComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
